import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const FormFileUploadInfo = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    const updatedClasses = classes.push('w-file-upload-info');
    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: FormFileUploadInfo,
  fields: {children: TListOfElement},
});

export default config;
